import React, { ChangeEvent, ReactNode } from 'react';

import { Input, InputType } from 'pages/checkout-v3/components/common/Input';
import { LabeledInput } from 'pages/checkout-v3/components/common/LabeledInput/LabeledInput';

interface AutocompleteConfig {
  showSuffix?: boolean;
  filterBy?: string[];
  autoSelectOnBlur?: boolean;
}

export interface FormInputConfig extends AutocompleteConfig {
  id?: string;
  label: string;
  type: InputType;
  required?: boolean;
  isSensitive?: boolean;
  value: any;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  errorMessage?: string;
  tooltip?: string;
  subtext?: string;
  endContent?: ReactNode;
  options?: any[];
  placeholderText?: string;
  onSelect?: (value: string) => void;
  gridSpan?: number;
  autoComplete?: string;
}

export const FormInputs = ({ inputConfigs }: { inputConfigs: FormInputConfig[]; }) => (
  <>
    {inputConfigs.map((config, index) => (
      <LabeledInput
        key={`${config.id || config.label}-${index}`}
        label={config.label}
        tooltip={config.tooltip}
        subtext={config.subtext}
        htmlFor={config.id}
        endContent={config.endContent}
      >
        <Input
          id={config.id}
          type={config.type}
          required={config.required}
          isSensitive={config.isSensitive ?? true}
          value={config.value}
          defaultSelected={config.value}
          onChange={config.onChange}
          errorMessage={config.errorMessage}
          options={config.options}
          placeholderText={config.placeholderText}
          onSelect={config.onSelect}
          autoComplete={config.autoComplete}
          // Autocomplete props
          showSuffix={config.showSuffix}
          filterBy={config.filterBy}
          autoSelectOnBlur={config.autoSelectOnBlur}
        />
      </LabeledInput>
    ))}
  </>
);
export const commonBirthDateConfig: Pick<FormInputConfig, 'type' | 'placeholderText' | 'showSuffix' | 'filterBy' | 'autoSelectOnBlur'> = {
  type: InputType.AUTOCOMPLETE,
  placeholderText: 'Select',
  showSuffix: false,
  filterBy: ['name', 'id'],
  autoSelectOnBlur: true,
};
